module.exports = __webpack_public_path__ + "static/media/landing.3146387b.jpg";